import Glightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

function makeGalleries() {
  Glightbox({});
}

export default makeGalleries;
